var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 11.5,
    stroke: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4297 60C13.4297 95.8493 52.2377 118.255 83.2841 100.33C97.6928 92.0115 106.569 76.6377 106.569 60C106.569 24.1507 67.7609 1.74483 36.7145 19.6696C22.3058 27.9884 13.4297 43.3623 13.4297 60Z",
    fill: "#F7EDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0175 95.9785C47.0175 97.5246 59.2906 98.4907 69.109 97.7178C73.6658 97.359 76.4728 96.696 76.4728 95.9785C76.4728 94.4325 64.1998 93.4663 54.3814 94.2393C49.8246 94.598 47.0175 95.261 47.0175 95.9785Z",
    fill: "#EB9DCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2055 83.4746C38.2029 84.2687 38.8456 84.914 39.6398 84.9147H81.23C82.0218 84.914 82.6637 84.2722 82.6643 83.4804V36.8642L70.477 24.6746H39.6398C38.8476 24.6747 38.2055 25.3168 38.2055 26.1089V83.4746Z",
    fill: "white",
    stroke: "#BB448B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.68 40.8H77.1519V72.933H43.68V40.8Z",
    fill: "#F7EDF3",
    stroke: "#BB448B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9063 53.1403C50.9015 56.2439 54.2583 58.1889 56.9486 56.6412C58.201 55.9207 58.972 54.5851 58.9698 53.1403C58.9746 50.0366 55.6178 48.0917 52.9276 49.6394C51.6751 50.3599 50.9041 51.6955 50.9063 53.1403Z",
    fill: "white",
    stroke: "#BB448B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1143 66.5197V70.2582C77.1143 71.737 75.9154 72.9358 74.4366 72.9359H46.3178C44.8389 72.9359 43.6401 71.7371 43.6401 70.2582V67.7328L50.5021 61.7266C51.2978 61.0194 52.5083 61.0604 53.2543 61.8197L56.0078 64.5743C56.5306 65.0969 57.378 65.0969 57.9008 64.5743L66.3998 56.0753C66.8091 55.6607 67.3816 55.4495 67.9622 55.4991C68.5478 55.5286 69.088 55.8229 69.4303 56.2989L77.1143 66.5197Z",
    fill: "white",
    stroke: "#BB448B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6662 36.8642H71.8143C71.0762 36.8623 70.4789 36.2635 70.4789 35.5253V24.6746L82.6662 36.8642Z",
    fill: "#F7EDF3",
    stroke: "#BB448B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderDashboard);
export default __webpack_public_path__ + "static/media/placeholder_dashboard.22c66bae01a5741b69a6e8581a887436.svg";
export { ForwardRef as ReactComponent };